import InputFieldContainer, { InputFieldContainerProps } from './InputFieldContainer';
import { useWidgetContext } from '../context/WidgetContext';

export default function PasswordField(props: InputFieldContainerProps) {

  const { athenaOneWebSso } = useWidgetContext();

  if (athenaOneWebSso) {
    return <></>;
  }
  return (
    <InputFieldContainer {...props} id="athena-password" />
  );
}
